@if (deductions.length) {
<table mat-table [dataSource]="deductions" class="table-deduction mat-elevation-z2">
	<ng-container matColumnDef="date">
		<td mat-cell *matCellDef="let deduction" class="table-data-sytle color-date">
			{{ deduction.deductionDate | date : "dd/MM/yyyy" }}
		</td>
	</ng-container>

	<ng-container matColumnDef="paymentMethod">
		<td mat-cell *matCellDef="let element" class="table-data-sytle color-data">
			<div class="badge-container flex flex-row">
				<div class="badge-item-mobile badge-mobile">
					<app-icon class="mobile-icon" [name]="'mobile'"></app-icon>
				</div>
				<b>{{ "WITHDRAWALS" }}</b>
			</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="amount">
		<td mat-cell *matCellDef="let deduction" class="table-data-sytle color-data">
			<div class="flex flex-row flex-align-center-start">
				<div class="amount-info flex flex-1" style="--max-witdh: 35%">
					<b>{{ deduction.amount.value | number }} {{ deduction.amount.currency | currencySymbol }}</b>
				</div>
			</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="type">
		<td mat-cell *matCellDef="let deduction" class="table-data-sytle color-data">
			{{ "PoD" }}
		</td>
	</ng-container>
	<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
}
